export default __webpack_public_path__ + "static/image-50-4d83156d7bf570ce48cafbeb73a97cc2.jpg";